import { Ability } from '@casl/ability'
import { initialAbility } from './config'

const userData = window.$cookies.get('userData')
const existingAbility = userData ? userData.ability : null

export default new Ability(existingAbility || initialAbility)
